export default angular
  .module("ShowStatusHistoryCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ShowStatusHistoryController", [
    "$scope",
    "scriptData",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    function (
      $scope,
      scriptData,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
    ) {
      $scope.ok = function () {
        $modalInstance.close();
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
      const scriptID = scriptData.ID;
      Scripts.loadScriptStatusHistoryByID(scriptID, (data) => {
        $scope.statushistory = data;
      });
    },
  ]);
